import React from 'react';
import { CellInfo } from 'react-table';
import { ColumnFactory } from '../ColumnFactory';

export const columnWithCustomCell = (accessor: string, name: string, cell: (cell: CellInfo) => React.ReactNode) => {
    return ColumnFactory.getColumnOptionsOld(accessor, name, cell);
}